var map = {
	"./data.cs.json": 4631,
	"./data.da.json": 9734,
	"./data.de.json": 1946,
	"./data.en-AU.json": 8223,
	"./data.en-CA.json": 6561,
	"./data.en-EU.json": 1947,
	"./data.en-GB.json": 6168,
	"./data.en-US.json": 2561,
	"./data.es.json": 9633,
	"./data.fr-CA.json": 4856,
	"./data.fr.json": 1513,
	"./data.hu-HU.json": 3506,
	"./data.it.json": 3844,
	"./data.nl.json": 2115,
	"./data.no.json": 6866,
	"./data.pl.json": 9441,
	"./data.pt.json": 9961,
	"./data.ru.json": 628,
	"./data.sl.json": 3650,
	"./data.sv.json": 5896
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7436;